import { useNavigate } from 'react-router-dom';
// mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// component
import SFBottomNavigation from '@/component/common/sf-bottom-navigator';
import BottomFix from '@/component/common/bottom-fix';
import SFFlagKoreaIcon from '@/component/icons/sf-flag-korea-icon';
import SFKoreaWon from '@/component/icons/sf-korea-won-icon';
// lib & store
import { SFPalette } from '@/lib/color';
import IconBundleInfo from './index/IconBundleInfo';
import { fontWeight, inter } from '@/theme';
// hook
import ListBundleNotice from './index/ListBundleNotice';
import MyPageInfo from './index/MyPageInfo';
import Langs from './settings/Langs';

export default function MyPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box bgcolor={theme.palette.primary.main}>
      <Box display="flex" flexDirection="column" height="100%" gap={4} minHeight={750}>
        <Container maxWidth="sm">
          <IconButton
            sx={{
              position: 'absolute',
              top: 2,
              right: 2,
            }}
          >
            {/* <CloseIcon
          sx={{
            color: 'white',
          }}
        /> */}
          </IconButton>
          {/* <Langs /> */}
          <IconButton
            sx={{
              p: 0,
              mb: 3.5,
            }}
            onClick={() => {
              navigate('/my/settings');
            }}
          >

            {/*<Stack direction="row" gap={3}>
              <Stack direction="row" alignItems="center" height={48}>
                <SFFlagKoreaIcon />
                <Typography
                  ml={1}
                  variant="subtitle2"
                  color="white"
                  textAlign="center"
                  fontWeight={fontWeight.Bold}
                  fontFamily={inter.style.fontFamily}
                >
                  KOR
                </Typography>
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                  }}
                />
              </Stack>
               <Stack direction="row" alignItems="center" height={48}>
                <SFKoreaWon />
                <Typography
                  ml={1}
                  variant="subtitle2"
                  color="white"
                  textAlign="center"
                  fontWeight={fontWeight.Bold}
                  fontFamily={inter.style.fontFamily}
                >
                  KWR
                </Typography>
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                  }}
                />
              </Stack>
            </Stack>*/}
          </IconButton>
          <MyPageInfo />
        </Container>
        <Box
          pt={5}
          left={0}
          bottom={0}
          flex={1}
          width="100%"
          bgcolor={SFPalette.lightGrey3}
          sx={{
            '&': {
              borderTopLeftRadius: '30px',
              borderTopRightRadius: '30px',
            },
          }}
        >
          <Container
            maxWidth="sm"
            sx={{
              position: 'relative',
            }}
          >
            <Box
              sx={{
                width: '100%',
                // border: "4px solid red",
                position: 'absolute',
                top: -120,
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            ></Box>
            {/* <IconBundleInfo /> */}
            <ListBundleNotice />

            <Typography variant="caption" component="h6" color={SFPalette.lightGrey2} textAlign="center" mb={2.5}>
              고객센터 help@hupayx.com
            </Typography>
          </Container>
        </Box>
      </Box>
      <BottomFix enableHeight={false}>
        <SFBottomNavigation selectedLabel="MY" />
      </BottomFix>
    </Box>
  );
}
